import { render, staticRenderFns } from "./magic.vue?vue&type=template&id=5f36caba&scoped=true&"
import script from "./magic.vue?vue&type=script&lang=js&"
export * from "./magic.vue?vue&type=script&lang=js&"
import style0 from "./magic.vue?vue&type=style&index=0&id=5f36caba&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f36caba",
  null
  
)

export default component.exports